import values from 'mout/object/values'
import sortByPropText from "../../content/manageSets/sortByPropText";

// Finds the first incomplete subtest in a userAssessment
export default function findFirstIncompleteSubtest(userAssessment) {
  if (userAssessment) {
    const sortedSubtests = sortByPropText(values(userAssessment.assessmentSubtests), 'index')
    let output = {}
    sortedSubtests.some(subtest => {
      const complete = userAssessment.destructuredSubtests[subtest.setId].complete === true
      if (!complete) {
        output = {...subtest}
        return true
      } else return false
    })
    return output
  } else return {}
}



// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentDashboard/findFirstIncompleteSubtest.js